export default {
  'discount.title': 'Discount rate',
  'discount.minRevenue': 'Minimum revenue (VND)',
  'discount.discountLevel': 'Discount rate',
};
